module.exports = __webpack_public_path__ + "img/esewa_logo_black.81ba1231.png";